<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal">
		<!-- <el-menu-item
			v-for="(item, index) in menu"
			:key="index"
			:index="item.link"
			>{{ item.title }}</el-menu-item> -->
		<router-link
			class="el-menu-item"
			v-for="(item, index) in menu"
			:key="index"
			:to="item.link"
			>{{ item.title }}</router-link
		>
    </el-menu>
  </div>
</template>
<script>
export default {
	props: {
		menu: {
			type: Array,
			default: () => []
		}
	},
	created () {
		this.initActive()
	},
	methods: {
		initActive () {
			const { path } = this.$route
			if (this.menu.length && !this.menu.some(item => item.link == path)) {
				this.$router.push(this.menu[0].link)
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.router-link-active {
  border-bottom: 2px solid #1890ff;
  color: #303133;
}
</style>
